import React from "react";
import classes from "./styles/Calendar.module.scss";

export function CalendarWrapper({ children }) {
  return <div className={classes.calendarWrapper}>{children}</div>;
}
